import { buildLink } from "@/helpers/slugHelper";
import { reportError } from "../errorHelper";

export const generateBreadcrumbsList = async (productTags) => {
  try{
  productTags = productTags.reverse(); // To get latest tag first

  let flag = false;

  const matchStrings = [
    "categories.lvl2:",
    "categories.lvl1:",
    "categories.lvl0:",
  ];

  let breadCrumbsArr = null;
  let ret = [];

  // Will loop through all tags and check if categories.lvl2 exists first, if it doesn't exist, will loop all tags again and check for categories.lvl1, finally same will be done for categories.lvl0 if lvl1 doesn't exist
  // As soon as a matching category is found, breadcrumb data will be returned and loops will be broken
  if (productTags) {
    for (let i = 0; i < matchStrings.length; i++) {
      for (let j = 0; j < productTags.length; j++) {
        if (productTags[j].startsWith(matchStrings[i])) {
          let link = "/products";
          breadCrumbsArr = productTags[j]
            .replace(matchStrings[i], "")
            .split(">");
            if(matchStrings[i] === 'categories.lvl2:') {
              link = await buildLink(breadCrumbsArr[0].trim(),breadCrumbsArr[1].trim(),breadCrumbsArr[2].trim());
              ret.push( {
                    link: link,
                    text: breadCrumbsArr[2],
                  })
              link = await buildLink(breadCrumbsArr[0].trim(),breadCrumbsArr[1].trim());
              ret.push( {
                link: link,
                text: breadCrumbsArr[1],
              })
              link = await buildLink(breadCrumbsArr[0].trim());
              ret.push({
                link: link,
                text: breadCrumbsArr[0],
              })
              flag = true;
              break;
            } else if(matchStrings[i] === 'categories.lvl1:') {
              link = await buildLink(breadCrumbsArr[0].trim(),breadCrumbsArr[1].trim());
              ret.push({
                link: link,
                text: breadCrumbsArr[1],
              })
              link = await buildLink(breadCrumbsArr[0].trim());
              ret.push({
                link: link,
                text: breadCrumbsArr[0],
              })
              flag = true;
              break;
            } else if(matchStrings[i] === 'categories.lvl0:') {
              link = await buildLink(breadCrumbsArr[0].trim());
              ret.push({
                link: link,
                text: breadCrumbsArr[0],
              })
              flag = true;
              break;
            }
        }
      }
      if(flag) break;
    }
  }

  return ret.reverse();
} catch (error){
  reportError(error)
  return []
}
};
